"use strict";

const Debug = require('debug');

const {
  httpRequest
} = require('../utils/api-utils');

const {
  addressSchema,
  throwIfMissing,
  positiveIntSchema
} = require('../utils/validator');

const debug = Debug('iexec:sms:check'); // used for dataset key

const checkWeb3SecretExists = async function () {
  let contracts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : throwIfMissing();
  let smsURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : throwIfMissing();
  let resourceAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : throwIfMissing();

  try {
    const vResourceAddress = await addressSchema({
      ethProvider: contracts.provider
    }).validate(resourceAddress);
    const res = await httpRequest('HEAD')({
      api: smsURL,
      endpoint: '/secrets/web3',
      query: {
        secretAddress: vResourceAddress
      }
    }).catch(e => {
      debug(e);
      throw Error("SMS at ".concat(smsURL, " didn't answered"));
    });

    if (res.ok) {
      return true;
    }

    if (res.status === 404) {
      return false;
    }

    throw Error("SMS answered with unexpected status: ".concat(res.status, " ").concat(res.statusText));
  } catch (error) {
    debug('checkWeb3SecretExists()', error);
    throw error;
  }
}; // used for beneficiary key


const checkWeb2SecretExists = async function () {
  let contracts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : throwIfMissing();
  let smsURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : throwIfMissing();
  let ownerAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : throwIfMissing();
  let secretName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : throwIfMissing();

  try {
    const vOwnerAddress = await addressSchema({
      ethProvider: contracts.provider
    }).validate(ownerAddress);
    const res = await httpRequest('HEAD')({
      api: smsURL,
      endpoint: '/secrets/web2',
      query: {
        ownerAddress: vOwnerAddress,
        secretName
      }
    }).catch(e => {
      debug(e);
      throw Error("SMS at ".concat(smsURL, " didn't answered"));
    });

    if (res.ok) {
      return true;
    }

    if (res.status === 404) {
      return false;
    }

    throw Error("SMS answered with unexpected status: ".concat(res.status, " ").concat(res.statusText));
  } catch (error) {
    debug('checkWeb2SecretExists()', error);
    throw error;
  }
};

const checkRequesterSecretExists = async function () {
  let contracts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : throwIfMissing();
  let smsURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : throwIfMissing();
  let requesterAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : throwIfMissing();
  let secretName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : throwIfMissing();

  try {
    const vRequesterAddress = await addressSchema({
      ethProvider: contracts.provider
    }).validate(requesterAddress);
    const res = await httpRequest('HEAD')({
      api: smsURL,
      endpoint: "/requesters/".concat(vRequesterAddress, "/secrets/").concat(secretName)
    }).catch(e => {
      debug(e);
      throw Error("SMS at ".concat(smsURL, " didn't answered"));
    });

    if (res.ok) {
      return true;
    }

    if (res.status === 404) {
      return false;
    }

    throw Error("SMS answered with unexpected status: ".concat(res.status, " ").concat(res.statusText));
  } catch (error) {
    debug('checkRequesterSecretExists()', error);
    throw error;
  }
};

const checkAppSecretExists = async function () {
  let contracts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : throwIfMissing();
  let smsURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : throwIfMissing();
  let appAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : throwIfMissing();
  let secretIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  try {
    const vAppAddress = await addressSchema({
      ethProvider: contracts.provider
    }).validate(appAddress);
    const vSecretIndex = await positiveIntSchema().validate(secretIndex);
    const res = await httpRequest('HEAD')({
      api: smsURL,
      endpoint: "/apps/".concat(vAppAddress, "/secrets/").concat(vSecretIndex)
    }).catch(e => {
      debug(e);
      throw Error("SMS at ".concat(smsURL, " didn't answered"));
    });

    if (res.ok) {
      return true;
    }

    if (res.status === 404) {
      return false;
    }

    throw Error("SMS answered with unexpected status: ".concat(res.status, " ").concat(res.statusText));
  } catch (error) {
    debug('checkRequesterSecretExists()', error);
    throw error;
  }
};

module.exports = {
  checkWeb3SecretExists,
  checkWeb2SecretExists,
  checkRequesterSecretExists,
  checkAppSecretExists
};